export const CONSTANT = {
  COLORS: {
    // PRIMARY_COLOR: '#376DF8', // SALESCORE
    PRIMARY_COLOR: '#0BB7B7', // カミナシ
  },
  localStorageKey: {
    USER_INFO_FOR_LOG: 'USER_INFO_FOR_LOG',
  },
}
